module.exports = "/integrations/components/integrationEntry/integrationEntry-a6e7b1.html";